module.exports = __webpack_public_path__ + "img/109.8.56b37aa1.png";